import React, {Component} from 'react';
import './assets/css/script.css';
import './assets/css/script_anmiation.css';
import {HashRouter, Route, Switch} from "react-router-dom";
import Script from "./views/Script";
import Result from "./views/Result";
import Main from "./views/Main";
import ReactGA from "react-ga";

ReactGA.initialize('UA-70840070-9');

class App extends Component {
    render() {
        return (
            <div className="App">
                <HashRouter>
                    <Switch>
                        <Route exact path='/' name="main" render={(props => <Main {...props}/>)}/>
                        <Route path='/play' name="script" render={(props => <Script {...props}/>)}/>
                        <Route path='/result/:id' name="result" render={(props => <Result {...props}/>)}/>
                    </Switch>
                </HashRouter>
            </div>
        );
    }
}

export default App;


